import React, { createContext, useContext, useState } from 'react';

const NotebookSidebarContext = createContext({ content: null, setContent: () => {} });

export const NotebookSidebarProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  return (
    <NotebookSidebarContext.Provider value={{ content, setContent }}>
      {children}
    </NotebookSidebarContext.Provider>
  );
};

export const useNotebookSidebar = () => useContext(NotebookSidebarContext);

export default NotebookSidebarContext;
